import React, { Component } from 'react';
import classNames from 'classnames';

class SiteNav extends Component {

    handleNavItemClick( site ) {

        let { siteActions } = this.props;
        siteActions.setActive( site );

    }

    renderNavItem( site, key, activeSite ) {

        let itemClass = classNames({
            'nav-item': true,
            'active': ( activeSite === site ) ? true : false
        });

        return(

            <li className={itemClass} key={ key }>
                <a className="nav-link" href="#" onClick={ this.handleNavItemClick.bind( this, site ) }>{site.name}</a>
            </li>

        )

    }

    render() {

        let { sites } = this.props;

        return (
            <ul className="nav navbar-nav">

                {
                    sites.items.map( ( site, key ) => {
                        return this.renderNavItem( site, key, sites.activeSite );
                    })
                }

            </ul>
        )
    }

}

export default SiteNav;


/** WEBPACK FOOTER **
 ** ./src/components/NavBar/SiteNav/index.js
 **/